(function(window, angular) {
  "use strict";
  var m = angular.module("vvCommon");

  m.service('vvPopup', function($q, $templateRequest, $timeout, vvBrowser) {
    var currentPopupHandler = null;
    this.setHandler = function(popupHandler) {
      currentPopupHandler = popupHandler;
    };

    this.open = function(template, data) {
      if (!currentPopupHandler)
      return $q.reject('no popup handler');

      return currentPopupHandler.open(template, data);
    };

    this.openUrl = function(templateUrl, data) {
      if (!currentPopupHandler)
      return $q.reject('no popup handler');

      return $templateRequest(templateUrl)
      .then(function(template) {
        return currentPopupHandler.open(template, data);
      });
    };

    this.close = function() {
      if (!currentPopupHandler)
      return $q.reject('no popup handler');

      return currentPopupHandler.close();
    };

    this.toast = function(text, duration) {
      var templateUrl = '/m/toastLayer.html?_hv=ff559c6';
      if (!currentPopupHandler)
      return $q.reject('no popup handler');

      return $templateRequest(templateUrl)
      .then(function(template) {
        currentPopupHandler.open(template, {desc: text});
        $timeout(function() { return currentPopupHandler.close(true, 1000); }, duration);
      });
    };

    this.confirm = function(text) {
      var templateUrl = '/m/confirmLayer.html?_hv=99d6ea6';
      if (!currentPopupHandler)
      return $q.reject('no popup handler');

      return $templateRequest(templateUrl)
      .then(function(template) {
        return currentPopupHandler.open(template, {title: '', desc: text});
      });
    };

    this.alert = function(text) {
      var templateUrl = '/m/alertLayer.html?_hv=d0a8824';
      if (!currentPopupHandler)
      return $q.reject('no popup handler');

      return $templateRequest(templateUrl)
      .then(function(template) {
        return currentPopupHandler.open(template, {title: '', desc: text});
      });
    };

    this.prompt = function(text, link) {
      var templateUrl = '/m/promptLayer.html?_hv=f7b228d';
      if (!currentPopupHandler)
      return $q.reject('no popup handler');

      var linkType = 'text';
      if (vvBrowser.isSafari() && vvBrowser.isMobile())
      linkType = 'link';

      if (vvBrowser.isiOSBuiltIn() && vvBrowser.isFacebookBuiltIn())
      linkType = 'link';

      return $templateRequest(templateUrl)
      .then(function(template) {
        return currentPopupHandler.open(template, {title: '', desc: text, link: link, linkType: linkType});
      });
    };
  });
})(window, window.angular);
